/* eslint-disable no-unused-vars */
export enum RoutesEnum {
  HOME = '/',
  LOGIN = '/login',
  REGISTER = '/register',
  LABS_LIST = '/labs',
  REGISTER_WITH_ACCESS_CODE = '/register/access-code',
  REGISTER_VERIFICATION_CODE = '/register/verification-token/:validationChecker',
  PROCESSED_EXAMS = '/exams/:extractionId',
  PROCESS_EXAMS = '/exams/process',
  PROCESS_EXAMS_TYPE = '/exams/process/type',
  PROCESS_EXAMS_REQUEST_LAB = '/exams/process/request-lab',
  FORGOT_PASSWORD = '/forgot-password',
  FORGOT_PASSWORD_VERIFICATION_CODE = '/forgot-password/verification-code',
  LOGOUT = '/logout',
  PROFILE = '/profile',
  SUBSCRIPTION = '/subscripiton',
  SUBSCRIPTION_STATEMENT = '/subscripiton/statement',
  FAQ = '/support/faq',
  CONTACT = '/support/contact',
  PATIENTS = '/patients',
  PATIENTS_VIEW = '/patients/view/:patientId',
  PATIENTS_CREATE = '/patients/create',
  PATIENTS_EDIT = '/patients/:patientId',
}
